import { getApiClient } from "../client";
import { EXCHANGE_ACCOUNT_POPULATE, EXCHANGE_POPULATE } from "../populate";
import { ExchangeAccountCreateInputSchema, ExchangeAccountQueryParamsSchema, ExchangeAccountSchema, ExchangeAccountUpdateInputSchema, ExchangeSchema, MoveExchangeAccountInputSchema, StrapiIdSchema, ValidateServerInputSchema, ValidateServerResultSchema, validateInput, } from "../schemas";
import { parseStrapiItemResponse, parseStrapiListResponse } from "../utils/parseStrapiResponse";
export const exchangeAccountsEndpoints = {
    async getExchangeAccount(id, params) {
        const validatedId = validateInput(StrapiIdSchema, id, "exchangeAccountsEndpoints.getExchangeAccount");
        const populate = params?.populate ?? EXCHANGE_ACCOUNT_POPULATE.FULL;
        const response = await getApiClient().get(`/exchange-accounts/${validatedId}`, {
            params: { populate },
        });
        return parseStrapiItemResponse(response.data, {
            schema: ExchangeAccountSchema,
            populate,
            context: "exchangeAccountsEndpoints.getExchangeAccount",
        });
    },
    async getExchangeAccounts(params) {
        const validated = params
            ? validateInput(ExchangeAccountQueryParamsSchema, params, "exchangeAccountsEndpoints.getExchangeAccounts")
            : undefined;
        const populate = params?.populate ?? EXCHANGE_ACCOUNT_POPULATE.DEFAULT;
        const response = await getApiClient().get("/exchange-accounts", {
            params: {
                populate,
                ...validated,
            },
        });
        return parseStrapiListResponse(response.data, {
            schema: ExchangeAccountSchema,
            populate,
            context: "exchangeAccountsEndpoints.getExchangeAccounts",
        });
    },
    async getMyExchangeAccounts(params) {
        const validated = params
            ? validateInput(ExchangeAccountQueryParamsSchema, params, "exchangeAccountsEndpoints.getMyExchangeAccounts")
            : undefined;
        const populate = params?.populate ?? EXCHANGE_ACCOUNT_POPULATE.DEFAULT;
        const response = await getApiClient().get("/exchange-accounts/me", {
            params: {
                populate,
                ...validated,
            },
        });
        return parseStrapiListResponse(response.data, {
            schema: ExchangeAccountSchema,
            populate,
            context: "exchangeAccountsEndpoints.getMyExchangeAccounts",
        });
    },
    async createExchangeAccount(input) {
        const validated = validateInput(ExchangeAccountCreateInputSchema, input, "exchangeAccountsEndpoints.createExchangeAccount");
        const response = await getApiClient().post("/exchange-accounts", {
            data: validated,
        });
        return parseStrapiItemResponse(response.data, {
            schema: ExchangeAccountSchema,
            context: "exchangeAccountsEndpoints.createExchangeAccount",
        });
    },
    /** Checks an MT5 server name before the account form is submitted; no credentials are sent. */
    async validateServer(input) {
        const validated = validateInput(ValidateServerInputSchema, input, "exchangeAccountsEndpoints.validateServer");
        const response = await getApiClient().post("/exchange-accounts/validate-server", validated);
        return ValidateServerResultSchema.parse(response.data);
    },
    async updateExchangeAccount(id, input) {
        const validatedId = validateInput(StrapiIdSchema, id, "exchangeAccountsEndpoints.updateExchangeAccount");
        const validated = validateInput(ExchangeAccountUpdateInputSchema, input, "exchangeAccountsEndpoints.updateExchangeAccount");
        const response = await getApiClient().put(`/exchange-accounts/${validatedId}`, {
            data: validated,
        });
        return parseStrapiItemResponse(response.data, {
            schema: ExchangeAccountSchema,
            context: "exchangeAccountsEndpoints.updateExchangeAccount",
        });
    },
    async moveExchangeAccount(input) {
        const validated = validateInput(MoveExchangeAccountInputSchema, input, "exchangeAccountsEndpoints.moveExchangeAccount");
        const { id, fromUserId, toUserId } = validated;
        const response = await getApiClient().post(`/exchange-accounts/${id}/move`, {
            data: { fromUser: fromUserId, toUser: toUserId },
        });
        return parseStrapiItemResponse(response.data, {
            schema: ExchangeAccountSchema,
            context: "exchangeAccountsEndpoints.moveExchangeAccount",
        });
    },
};
export const exchangesEndpoints = {
    async getExchanges(params) {
        const populate = params?.populate ?? EXCHANGE_POPULATE.DEFAULT;
        const response = await getApiClient().get("/exchanges", {
            params: { populate },
        });
        return parseStrapiListResponse(response.data, {
            schema: ExchangeSchema,
            populate,
            context: "exchangesEndpoints.getExchanges",
        });
    },
};
